import { useState } from "react";
import { PriceData } from "./token-swap";
import { useNavigate, useNavigation } from "react-router";
import { classNames } from "~/lib/util";

type Props = {
   priceData: PriceData
};

export default function TokenPrice({ priceData }: Props) {
   const naviation = useNavigation();
   const [direction, setDirection] = useState(true);

   function onSwitch(event) {
      setDirection(!direction);
   }

   return priceData.inputAmount > 0 ? (
     <button
       type="button"
       onClick={onSwitch}
       className={classNames(
         naviation.state == "submitting" ? "bg-primary-200 animate-pulse rounded-sm" : "",
         "hover:text-primary-700 dark:hover:text-primary-100 lining-num text-xs font-normal lg:text-base",
       )}
     >
       {direction ? (
         <>
           1 {priceData.inputToken.symbol} = {(priceData.outputAmount / priceData.inputAmount).toFixed(6)} {priceData.outputToken.symbol}
         </>
       ) : (
         <>
           1 {priceData.outputToken.symbol} = {(priceData.inputAmount / priceData.outputAmount).toFixed(6)} {priceData.inputToken.symbol}
         </>
       )}
     </button>
   ) : null;
}
